/**
 * DevicesStep - Step 3: Device configuration (PV, EV, Heat Pump).
 *
 * Three DeviceGateCards, each wrapping its config form.
 * "Nie mam żadnych urządzeń" option unchecks all.
 */

import { Stack, Text, Button } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import type { UseFormReturnType } from '@mantine/form';
import type { ProsumerFormValues } from '../../types';
import { DeviceGateCard } from '../devices/DeviceGateCard';
import { PVConfigForm } from '../devices/PVConfigForm';
import { EVConfigForm } from '../devices/EVConfigForm';
import { HeatPumpConfigForm } from '../devices/HeatPumpConfigForm';

export interface DevicesStepProps {
  form: UseFormReturnType<ProsumerFormValues>;
}

export function DevicesStep({ form }: DevicesStepProps) {
  const handleNoDevices = () => {
    form.setFieldValue('hasPV', false);
    form.setFieldValue('hasEV', false);
    form.setFieldValue('hasHeatPump', false);
  };

  return (
    <Stack gap="md">
      <Text fw={600} size="lg">Urządzenia</Text>

      <DeviceGateCard
        title="Fotowoltaika (PV)"
        description="Panele słoneczne na dachu"
        checked={form.values.hasPV}
        onChange={(checked) => form.setFieldValue('hasPV', checked)}
      >
        <PVConfigForm form={form} />
      </DeviceGateCard>

      <DeviceGateCard
        title="Samochód elektryczny (EV)"
        description="Ładowanie pojazdu elektrycznego"
        checked={form.values.hasEV}
        onChange={(checked) => form.setFieldValue('hasEV', checked)}
      >
        <EVConfigForm form={form} />
      </DeviceGateCard>

      <DeviceGateCard
        title="Pompa ciepła"
        description="Ogrzewanie pompą ciepła"
        checked={form.values.hasHeatPump}
        onChange={(checked) => form.setFieldValue('hasHeatPump', checked)}
      >
        <HeatPumpConfigForm form={form} />
      </DeviceGateCard>

      <Button
        variant="subtle"
        color="gray"
        leftSection={<IconX size={16} />}
        onClick={handleNoDevices}
      >
        Nie mam żadnych urządzeń
      </Button>
    </Stack>
  );
}
